import React from 'react'
import { oneOf, string } from 'prop-types'
import styled from '@emotion/styled'

const Card = styled.div`
  padding-top: 12px;
  color: white;
`

const Flex = styled.div`
  display: ${({ orientation }) => (orientation === 'landscape' ? 'flex' : 'inline-flex')};
  flex-wrap: ${({ orientation }) => (orientation === 'landscape' ? 'wrap' : 'no-wrap')};
  padding: 12px;
`

const PaddedP = styled.p`
  text-align: left;
  margin-left: 16px;
  font-weight: 200;
`

const Image = styled.img`
  border-radius: 2px;
  object-fit: cover;
`

const StoryCard = ({ image, text, orientation }) => {
  const imageSize = orientation === 'portrait'
    ? {
      height: 120,
    }
    : {
      width: 352,
    }
  return image ? (
    <Card>
      <Flex orientation={orientation}>
        <Image src={image} alt="card" {...imageSize} />
        <PaddedP>{text}</PaddedP>
      </Flex>
    </Card>
  ) : null
}

StoryCard.propTypes = {
  image: string,
  text: string.isRequired,
  orientation: oneOf(['portrait', 'landscape']),
}

StoryCard.defaultProps = {
  image: null,
  orientation: 'portrait',
}

export default StoryCard
